import { render, staticRenderFns } from "./WaveIteration.vue?vue&type=template&id=2a9188d9"
import script from "./WaveIteration.vue?vue&type=script&lang=js"
export * from "./WaveIteration.vue?vue&type=script&lang=js"
import style0 from "./WaveIteration.vue?vue&type=style&index=0&id=2a9188d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports